import * as React from 'react';
import styled from 'styled-components';
import { brightNavy, fieldBackgroundWhite, fieldBorder, grey26, sofiaFontBold } from '../../cssConstants';

const DotButton = <T,>({
	selected,
	position,
	className,
	disabled,
	onClick,
	text,
	value,
	showBorders,
	key
}: Props<T>) => (
	<Button
		selected={selected}
		position={position}
		showBorders={showBorders}
		className={className}
		type="button"
		onClick={onClick}
		disabled={disabled}
		data-value={value}
		key={key}
	>
		<Round selected={selected}>{selected && <Dot />}</Round>
		{text && <span className="label">{text}</span>}
	</Button>
);

interface Props<T> {
	text: string;
	value: T;
	selected: boolean;
	position?: Position;
	onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
	className?: string;
	disabled?: boolean;
	showBorders?: boolean;
	key?: string;
}

export type Position = 'first' | 'middle' | 'last';

DotButton.defaultProps = {
	position: undefined,
	className: undefined,
	disabled: false,
	onClick: undefined,
	showBorders: true
};

const Button = styled.button<{ selected: boolean; showBorders: boolean; position?: Position }>`
	display: inline-block;
	background-color: white;
	color: ${grey26};
	opacity: 0.6;
	margin: 0;
	padding: 7px 16px;
	${(props) =>
		props.selected &&
		`opacity: 1;
		font-weight: ${sofiaFontBold};`}
	${(props) => (props.showBorders ? 'border: 1px solid #cecdca;' : 'border: none; text-align: left;')}
	${(props) => {
		switch (props.position) {
			case 'first':
				return `border-radius: 8px 0 0 8px;`;
			case 'middle':
				return ``;
			case 'last':
				return `border-radius: 0 8px 8px 0;`;
			// null is treated different from undefined because we don't want to break the css for components that already use
			// this component.
			case null:
				return `border-radius: 8px;`;
			default:
				return ``;
		}
	}}
`;

const Round = styled.span<{ selected: boolean }>`
	display: inline-block;
	vertical-align: middle;
	line-height: 32px;
	border: ${fieldBorder};
	background-color: ${fieldBackgroundWhite};
	border-radius: 8px;
	width: 16px;
	height: 16px;
	margin-right: 5px;
	position: relative;
	${(props) => props.selected && `border: 1px solid ${brightNavy};`}
`;

const Dot = styled.span`
	background-image: initial;
	background-color: rgb(20, 52, 124);
	background: ${brightNavy};
	border-radius: 8px;
	width: 8px;
	height: 8px;
	position: absolute;
	top: 3px;
	left: 3px;
`;

export default DotButton;
